<template>
  <div>
    <div
      v-if="isLoadingJobs"
      v-loading="isLoadingJobs"
      style="height: 100px;"
    />
    <div v-if="!$_.isEmpty(jobs) && !isLoadingJobs">
      <div
        v-for="job in jobs"
        :key="job.id"
      >
        <div
          class="background-job-container"
        >
          <div>
            <b class="mb-2">{{ $_.get(job, 'description', '-') }}</b>
            <br>
            <span class="text-muted">
              <el-tag
                :type="getTagType($_.get(job, 'status', '-'))"
                size="mini"
              >{{ getText($_.get(job, 'status', '-')) }}</el-tag>&nbsp;{{ $moment(job.created_at).fromNow() }}
            </span>
          </div>
          <div>
            <vue-circle
              v-if="$_.get(job, 'status') === 1 || $_.get(job, 'status') === 2"
              :progress="getProgressPercentage(job)"
              :size="42"
              :reverse="false"
              :fill="$_.get(job, 'status') === 2 ? { color: '#28a745' } : { color: '#2e7bcc' }"
              :animation-start-value="0.0"
              :start-angle="0"
              insert-mode="append"
              :thickness="2"
              :show-percent="isShowPercentage(job)"
            >
              <span v-if="$_.get(job, 'status') === 2 && isValidUrl($_.get(job, 'result'))">
                <el-button
                  type="text"
                  size="mini"
                  @click="downloadExport($_.get(job, 'result'))"
                >
                  <FontAwesomeIcon
                    :icon="['fal', 'download']"
                    :style="{ color: '#28a745' }"
                  />
                </el-button>
              </span>
            </vue-circle>
            <vue-circle
              v-else-if="$_.get(job, 'status') === -2 || $_.get(job, 'status') === -1"
              :progress="100"
              :size="42"
              :reverse="false"
              :fill="{ color: '#f56c6c' }"
              :animation-start-value="0.0"
              :start-angle="0"
              insert-mode="append"
              :thickness="2"
              :show-percent="false"
            >
              <span>
                <FontAwesomeIcon
                  :icon="['fal', 'ban']"
                  :style="{ color: '#f56c6c' }"
                />
              </span>
            </vue-circle>
            <div
              v-else
              v-loading="true"
              style="width: 42px; height: 42px;"
            />
          </div>
        </div>
      </div>
      <el-pagination
        v-if="jobs.length > 0"
        class="text-center pt-3"
        :current-page.sync="page"
        :page-size.sync="jobs.limit"
        layout="prev, pager, next"
        :total="jobs.total"
        @size-change="loadBackgroundJobs"
        @current-change="loadBackgroundJobs"
      />
    </div>
    <div
      v-else-if="!isLoadingJobs && $_.isEmpty(jobs)"
      class="text-center p-4"
    >
      <FontAwesomeIcon
        :icon="['fal', 'microchip']"
        size="4x"
      />
      <br>
      <p>No background jobs found</p>
    </div>
  </div>
</template>

<script>
import VueCircle from 'vue2-circle-progress'
export default {
  components: {
    VueCircle
  },
  data () {
    return {
      progress: 60,
      isLoadingJobs: false,
      jobs: [],
      jobsInterval: null,
      page: 1,
      token: undefined
    }
  },
  mounted () {
    this.loadBackgroundJobs()
    this.$nextTick(async () => {
      this.token = await this.$session.token
    })
    this.jobsInterval = setInterval(() => {
      this.loadBackgroundJobs()
    }, 60000)
  },
  beforeDestroy () {
    clearInterval(this.jobsInterval)
  },
  methods: {
    loadBackgroundJobs () {
      this.isLoadingJobs = true
      this.$sdk.job.list(builder => {
        builder.order = 'created_at:desc'
        builder.limit = 10
        builder.page = this.page
      })
        .then(res => {
          this.jobs = res
        })
        .finally(() => { this.isLoadingJobs = false })
    },
    getTagType (status) {
      switch (status) {
        case -2:
          return 'danger'
        case -1:
          return 'danger'
        case 0:
          return ''
        case 1:
          return 'warning'
        case 2:
          return 'success'
      }
      return 'danger'
    },
    getText (status) {
      switch (status) {
        case -2:
          return 'Failed'
        case -1:
          return 'Cancelled'
        case 0:
          return 'Queued'
        case 1:
          return 'Processing'
        case 2:
          return 'Complete'
      }
      return 'error'
    },
    getProgressPercentage (job) {
      if (this.$_.get(job, 'status') === 2) {
        return 100
      } else if (this.$_.get(job, 'progress_percentage')) {
        return this.$_.get(job, 'progress_percentage')
      } else {
        return 0
      }
    },
    isShowPercentage (job) {
      if (this.$_.get(job, 'status') === 2 && this.isValidUrl(this.$_.get(job, 'result', '-'))) {
        return false
      } else {
        return true
      }
    },
    isValidUrl (string) {
      try {
        const url = new URL(string)
        if (url) {}
        return true
      } catch {
        return false
      }
    },
    downloadExport (url) {
      console.log('Downloading export from URL:', url)
      window.open(
        this.addSessionToURL(url),
        '_blank'
      )
    },
    addSessionToURL (url) {
      url = new URL(url)
      url.searchParams.set('session', this.token)
      return url.toString()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "variables";
.background-job-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 0px 7px 0px;
  border-bottom: 1px solid $light;
}
</style>
